// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-2dcd6906&scoped=true!../../../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./NewModal.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../../../../node_modules/vue-style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-2dcd6906&scoped=true!../../../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./NewModal.vue", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-2dcd6906&scoped=true!../../../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./NewModal.vue");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=_v-2dcd6906&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./resources/assets/javascript/components/ui/NewModal.vue
// module id = ./node_modules/vue-style-loader/index.js!./node_modules/css-loader/index.js?sourceMap!./node_modules/vue-loader/lib/style-rewriter.js?id=_v-2dcd6906&scoped=true!./node_modules/vue-loader/lib/selector.js?type=style&index=0!./resources/assets/javascript/components/ui/NewModal.vue
// module chunks = 53